import { render, staticRenderFns } from "./CharacterPanel.vue?vue&type=template&id=36af11f6&scoped=true"
import script from "./CharacterPanel.vue?vue&type=script&lang=js"
export * from "./CharacterPanel.vue?vue&type=script&lang=js"
import style0 from "./CharacterPanel.vue?vue&type=style&index=0&id=36af11f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af11f6",
  null
  
)

export default component.exports